export enum MedChronAssetTabs {
  ALL_EVENTS = 'all-events',
  DETAILED_VIEW = 'detailed-view',
  SOURCE_FILES = 'source-files',
}

export const getMedChronAssetTabName = (tab: MedChronAssetTabs) => {
  switch (tab) {
    case MedChronAssetTabs.ALL_EVENTS:
      return 'All Events'
    case MedChronAssetTabs.DETAILED_VIEW:
      return 'Detailed View'
    case MedChronAssetTabs.SOURCE_FILES:
      return 'Source Files'
  }
}

export enum MedChronAssetRouteSegments {
  ADD_FILES = 'add-files',
  LEGACY_REPORTS = 'legacy-reports',
}

// Update polling backs off 5s -> 10s -> 15s while a run is active.
export const kMedChronAssetPollIntervalsMs = [5000, 10000, 15000]

export const kMedChronAssetAcceptedFileTypes = {
  'application/pdf': ['.pdf'],
}
